import { render } from "./CabinetManagementModule.vue?vue&type=template&id=6e19d03a&scoped=true"
import script from "./CabinetManagementModule.vue?vue&type=script&lang=js"
export * from "./CabinetManagementModule.vue?vue&type=script&lang=js"

import "./CabinetManagementModule.vue?vue&type=style&index=0&id=6e19d03a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e19d03a"]])

export default __exports__